//
//
//
//
//
//
//
//

export default {
    name:'sm-footer',
    data() {
        return {

        }
    },
    components: {

    }
}



// WEBPACK FOOTER //
// ./node_modules/smart_webview_ui/src/components/sm_footer/sm_footer.vue